import { useState } from "react";
import PopupModal from "../../components/Modal/PopupModal";
const PricingCard = ({
  title,
  price,
  description,
  features = [],
  disabledFeatures = [],
}) => {
  const [getPopUpShow, setPopUpShow] = useState(false);
  const onhide = () => {
    setPopUpShow(false);
  };
  const handelclick = () => {
    setPopUpShow(true);
  };
  return (
    <>
      <PopupModal show={getPopUpShow} onHide={onhide} />
      <div className="pricing-card">
        <h4>{title}</h4>
        <p className="pricing-desc">{description}</p>

        {/* <h2 className="price">
          ${price} <span>/Month</span>
        </h2> */}

        <button className="pricing-btn" onClick={handelclick}>Contact Us</button>

        <ul className="feature-list">
          {features.map((item, i) => (
            <li key={i} className="enabled">
              ✓ {item}
            </li>
          ))}
          {disabledFeatures.map((item, i) => (
            <li key={i} className="disabled">
              ✕ {item}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default PricingCard;
